import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  size = 'default',
  href
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg';
  const motionProps = {
    className: `
      bg-gold-primary text-emerald-primary font-semibold rounded-full
      shadow-lg hover:shadow-2xl transition-all duration-300
      ${sizeClasses} ${className}
    `,
    whileHover: {
      scale: 1.05,
      boxShadow: '0 0 30px rgba(212, 175, 55, 0.5)'
    },
    whileTap: {
      scale: 0.98
    },
    'aria-label': typeof children === 'string' ? children : 'Call to action button'
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" {...motionProps} style={{
      display: 'inline-block',
      textDecoration: 'none'
    }} data-id="element-13">
        {children}
      </motion.a>;
  }
  return <motion.button onClick={onClick} {...motionProps} data-id="element-14">
      {children}
    </motion.button>;
}